<template>
  <div class="page-wrap stack-lg legal-page">
    <SectionTitle eyebrow="Документ" title="Политика конфиденциальности LightningBolt" subtitle="Краткая версия для мобильного приложения сети компьютерных клубов." />
    <BaseCard class="legal-card stack-md">
      <p>LightningBolt обрабатывает только те данные, которые нужны для авторизации, бронирования мест и связи с пользователем: email, телефон, имя, выбранный клуб и история броней.</p>
      <p>Файлы, которые пользователь прикладывает к брони, используются только для обработки заявки и не передаются третьим лицам без отдельного основания.</p>
      <p>Пользователь может запросить обновление своих данных через профиль или службу поддержки. Администраторы клуба получают доступ только к данным, необходимым для исполнения брони.</p>
    </BaseCard>
  </div>
</template>

<script>
import BaseCard from '../components/ui/BaseCard.vue';
import SectionTitle from '../components/ui/SectionTitle.vue';

export default {
  name: 'PrivacyPolicyView',
  components: { BaseCard, SectionTitle },
};
</script>

<style scoped src="./PrivacyPolicyView.css"></style>
